import Select, {SelectProps} from "@mui/material/Select";

const sx = {
    border: 0,
    boxShadow: "none",
    '.MuiOutlinedInput-notchedOutline': {
        border: 0
    },
    fontSize: '0.875rem',
    li: {
        fontSize: 'inherit'
    }
}

const InlineSelect = <Value = unknown>({size = "small", ...rest}: SelectProps<Value>) =>
    <Select size={size} {...rest} sx={sx} />

export default InlineSelect
